<template>
  <div
    class="gmfo"
    :class="{ 'gw_loading gw_loading_text': loading }"
    v-html="custName"
  ></div>
</template>

<script>
import { getCustomTreeNameConf } from '@/store/gameformat/gameformat'

export default {
  name: 'CustomformatOption',
  props: {
    customTree: Object,
    keys: {
      default: () => [
        'players', //
        'depth',
        'pot',
        'stack_and_blinds',
        'ante',
        'limps',
        'rake',
      ],
    },
    loading: [String, Boolean],
  },
  data() {
    return {}
  },

  computed: {
    custName() {
      //  let { players, depth, pot } = getCustomTreeNameConf({ customTree: this.customTree })
      if (this.loading) {
        // return '--IP vs OOP, Stack 99.9, Pot 9.9--'
        return '---------------------------------'
      }
      const keys = getCustomTreeNameConf({ customTree: this.customTree })
      let res = this.keys
        .filter(key => keys[key])
        .map(key => keys[key])
        .filter(i => i)

      res = res.join(' • ')
      return res
    },
  },
}
</script>
